__turbopack_context__.v({
  "chevron": "Bgow2G_chevron",
  "chevronOpen": "Bgow2G_chevronOpen",
  "header": "Bgow2G_header",
  "item": "Bgow2G_item",
  "panel": "Bgow2G_panel",
  "panelInner": "Bgow2G_panelInner",
  "panelOpen": "Bgow2G_panelOpen",
  "root": "Bgow2G_root",
  "title": "Bgow2G_title",
});
